// extracted by css-extract-rspack-plugin
export default {"tocCollapsibleButton":"tocCollapsibleButton_htYj","tocCollapsibleButtonExpanded":"tocCollapsibleButtonExpanded_pAh7"};